const process = fields =>
  fields
    .map(
      field => typeof field === 'string'
        ? field
        : Object.keys(field)
          .map(child => (`${child} {
            ${process(field[child])}
          }`))
    ).join('\n')

export default process
